import { render, staticRenderFns } from "./CaseDetails.vue?vue&type=template&id=7f2e6a32&"
import script from "./CaseDetails.vue?vue&type=script&lang=js&"
export * from "./CaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./CaseDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports